import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import {
  TrendingUp as ProfitabilityIcon,
  ShowChart as ForecastIcon,
  People as StaffIcon,
  People as ClientActivityIcon,
  Receipt as InvoiceSummaryIcon,
} from '@mui/icons-material';
import PageLayout from './ui/PageLayout';

const REPORTS_NAV = [
  { path: '/reports/profitability', label: 'Profitability', icon: <ProfitabilityIcon fontSize="small" /> },
  { path: '/reports/forecast', label: 'Revenue Forecast', icon: <ForecastIcon fontSize="small" /> },
  { path: '/reports/staff', label: 'Staff Utilization', icon: <StaffIcon fontSize="small" /> },
  { path: '/reports/client-activity', label: 'Client Activity', icon: <ClientActivityIcon fontSize="small" /> },
  { path: '/reports/invoice-summary', label: 'Invoice Summary', icon: <InvoiceSummaryIcon fontSize="small" /> },
];

const ReportsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <PageLayout sx={{ overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden', width: '100%' }}>
        <Box
          sx={{
            width: 200,
            flexShrink: 0,
            borderRight: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
            overflowY: 'auto',
          }}
        >
          <Box sx={{ px: 2, py: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
              Reports
            </Typography>
          </Box>
          <List disablePadding dense>
            {REPORTS_NAV.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <ListItemButton
                  key={item.path}
                  selected={isActive}
                  onClick={() => navigate(item.path)}
                  sx={{
                    py: 1.125,
                    borderRadius: 0,
                    borderLeft: 3,
                    borderLeftColor: isActive ? 'primary.main' : 'transparent',
                    bgcolor: isActive ? 'primary.light' : 'transparent',
                    '&.Mui-selected': {
                      bgcolor: 'primary.light',
                    },
                    '&:hover': {
                      bgcolor: isActive ? 'primary.light' : 'action.hover',
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 34 }}>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: isActive ? 600 : 400,
                      color: 'text.primary',
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto', p: 3, bgcolor: 'background.default' }}>
          <Outlet />
        </Box>
      </Box>
    </PageLayout>
  );
};

export default ReportsLayout;
